<div class="p-3">
	<rl-edit-entity [parentEntityId]="parentEntityId" [baseEntityId]="baseEntityId" [editingEntityId]="editingEntityId"
		[isRelative]="isRelative" [templateGroupId]="templateGroupId" (onComplete)="save($event)"
		(onCancel)="cancel()"></rl-edit-entity>
</div>